import { useEffect, useRef } from 'react';

const useOnMountFocus = () => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return inputRef;
};

export default useOnMountFocus;
